/* PB: Subcollection horizontal menu — init + zachování scrollu mezi prokliky */
document.addEventListener("DOMContentLoaded", function () {
  var scrollContainer = document.querySelector('.subcollection-scroll');
  if (!scrollContainer) return;

  // Spustit jen pokud je obsah širší než viewport
  if (scrollContainer.scrollWidth <= scrollContainer.clientWidth + 1) return;

  // Unikátní klíč podle typu menu (muži/ženy)
  var menuKey = 'subcollectionScrollLeft_' + (scrollContainer.dataset.menuType || 'default');
  var savedScroll = sessionStorage.getItem(menuKey);
  if (savedScroll !== null) {
    scrollContainer.scrollLeft = parseInt(savedScroll, 10);
  }
  var links = scrollContainer.querySelectorAll('a');
  links.forEach(function(link) {
    link.addEventListener('click', function() {
      sessionStorage.setItem(menuKey, scrollContainer.scrollLeft);
    });
  });
});

/* PB – propojené barevné varianty (kolekce/search, 1x/2x srcset, bezpečné vůči PDP) */
(function () {
  function findSwatchLinkFromEventTarget(target) {
    const link = target.closest('.group-swatch__link');
    if (link) return link;
    const label = target.closest('.variant-option__button-label');
    return label ? label.querySelector('.group-swatch__link') : null;
  }

  // Nastaví IMG src + (volitelně) srcset; u <picture><source> pouze srcset.
  // Zrcadlí i data-src/data-srcset kvůli případnému lazy-loaderu.
  function applyMedia(node, url1x, srcset) {
    if (!node) return;

    const img = node.tagName === 'IMG' ? node : node.querySelector('img');
    const picture = img ? img.closest('picture') : null;

    if (img && url1x) {
      img.setAttribute('src', url1x);
      if (img.hasAttribute('data-src')) img.setAttribute('data-src', url1x);
    }
    if (srcset) {
      if (img) {
        img.setAttribute('srcset', srcset);
        if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', srcset);
      }
      if (picture) {
        picture.querySelectorAll('source').forEach((s) => {
          s.setAttribute('srcset', srcset);
          if (s.hasAttribute('data-srcset')) s.setAttribute('data-srcset', srcset);
        });
      }
    }
  }

  function updateImages(card, linkEl) {
    const mainUrl   = linkEl.dataset.image || '';
    const mainSet   = linkEl.dataset.srcset || '';
    const secondUrl = linkEl.dataset.secondaryImage || '';
    const secondSet = linkEl.dataset.secondarySrcset || '';

    const root = card.querySelector('.card-gallery') || card;
    const nodes = root.querySelectorAll('picture > img, img');
    if (nodes[0] && (mainUrl || mainSet))    applyMedia(nodes[0], mainUrl,   mainSet);
    if (nodes[1] && (secondUrl || secondSet)) applyMedia(nodes[1], secondUrl, secondSet);
  }

  function updateCard(card, linkEl) {
    const targetUrl = linkEl.dataset.url || linkEl.getAttribute('href') || '';

    // Aktivní stav (rychle)
    const prev = card.querySelector('.group-swatch__link.is-active');
    if (prev && prev !== linkEl) prev.classList.remove('is-active');
    linkEl.classList.add('is-active');

    // Radio
    const input = linkEl.closest('label')?.querySelector('input[type="radio"]');
    if (input) input.checked = true;

    // Přesměrované odkazy (overlay, galerie, titulek)
    if (targetUrl) {
      const productLink = card.querySelector('.product-card__link, a[href*="/products/"]');
      if (productLink) productLink.setAttribute('href', targetUrl);
      const galleryLink = card.querySelector('[ref="cardGalleryLink"]');
      if (galleryLink) galleryLink.setAttribute('href', targetUrl);
      card.querySelectorAll('[ref="productTitleLink"], .product-card__title a, a.product-card__title, product-title a, h3 a[href*="/products/"]')
        .forEach((a) => a.setAttribute('href', targetUrl));
    }

    updateImages(card, linkEl);
    return true;
  }

  // Aktivace swatche pouze v GRIDu; vrací true, pokud jsme přepnuli kartu.
  function handleActivate(linkEl) {
    if (!linkEl) return false;

    const list = linkEl.closest('.group-swatches');
    if (!list || list.dataset.mode !== 'grid') return false; // klíčová pojistka proti PDP

    const card = linkEl.closest('.product-card');
    if (!card) return false;

    return updateCard(card, linkEl);
  }

  // Click
  document.addEventListener('click', function (e) {
    const link = findSwatchLinkFromEventTarget(e.target);
    if (!link) return;
    const handled = handleActivate(link);
    if (handled) {
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      e.stopPropagation();
    }
  }, true);

  // Klávesnice (Enter/Space)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const link = findSwatchLinkFromEventTarget(e.target);
    if (!link) return;
    const handled = handleActivate(link);
    if (handled) {
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      e.stopPropagation();
    }
  }, true);

  // Reset k výchozí variantě po návratu z detailu (bfcache) – opět jen v GRIDu
  function resetCardToDefault(card) {
    if (!card.querySelector('.group-swatches[data-mode="grid"]')) return;
    const swatches = card.querySelector('.group-swatches[data-default-url]');
    if (!swatches) return;
    const url = swatches.getAttribute('data-default-url');
    if (!url) return;
    const defaultLink = swatches.querySelector(`.group-swatch__link[data-url="${url}"]`);
    if (defaultLink) updateCard(card, defaultLink);
  }

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.product-card').forEach(resetCardToDefault);
  });
})();